(function () {
  function formatMoney(root) {
    (root || document).querySelectorAll('.product-info .money').forEach(function (node) {
      var formatted = node.textContent.replace(/(\d)\.(\d{2})(?!\d)/g, '$1,$2');
      if (formatted !== node.textContent) node.textContent = formatted;
    });
  }
  function bindHearts(root) {
    (root || document).querySelectorAll('.ugp-heart:not([data-ugp-bound])').forEach(function (button) {
      button.dataset.ugpBound = 'true';
      button.addEventListener('click', function () {
        var pressed = button.getAttribute('aria-pressed') === 'true';
        button.setAttribute('aria-pressed', pressed ? 'false' : 'true');
        button.setAttribute('aria-label', pressed ? button.dataset.labelAdd : button.dataset.labelRemove);
      });
    });
  }
  function normalizeDelivery(root) {
    (root || document).querySelectorAll('.product-info parcelpanel-edd').forEach(function (parcelPanel) {
      var widget = parcelPanel.querySelector('.parcelpanel-edd');
      if (!widget) return;
      var rows = widget.querySelectorAll(':scope > p');
      if (rows.length < 3) return;
      rows[rows.length - 1].childNodes.forEach(function (node) {
        if (node.nodeType === 3 && /:\s*$/.test(node.textContent)) node.textContent = node.textContent.replace(/:\s*$/, '');
      });

      var location = rows[0].querySelector('a[data-handle-id]');
      var countryCode = String(parcelPanel.country || '').toUpperCase();
      if (!location || !countryCode) return;

      var locale = String((window.Shopify && window.Shopify.locale) || document.documentElement.lang || 'en').replace('_', '-');
      var countryName = parcelPanel.countryName || countryCode;

      try {
        if (window.Intl && Intl.DisplayNames) {
          countryName = new Intl.DisplayNames([locale], { type: 'region' }).of(countryCode) || countryName;
        }
      } catch (error) {}

      if (location.textContent.trim() !== countryName) location.textContent = countryName;
    });
  }
  function normalizeDeadline(root) {
    (root || document).querySelectorAll('.product-info parcelpanel-edd .parcelpanel-edd').forEach(function (widget) {
      var rows = widget.querySelectorAll(':scope > p');
      if (rows.length < 3) return;
      var time = rows[1].querySelector('strong');
      if (time && time.textContent !== '23:59') time.textContent = '23:59';
    });
  }
  function normalizeReviewA11y(root) {
    (root || document).querySelectorAll('[data-ug-review-label]').forEach(function (button) {
      var label = button.dataset.ugReviewLabel;
      if (label && button.getAttribute('aria-label') !== label) button.setAttribute('aria-label', label);
    });
  }

  /* ------------------------------------------------------------------
     Delivery timeline: country flag + animated Order / Shipping / Delivery
     track, built from ParcelPanel's eddResult (country + delivery range).
     ParcelPanel's own block stays in the DOM as data source, hidden. If
     the range cannot be parsed the ParcelPanel block simply stays visible.
  ------------------------------------------------------------------ */
  var UGD_STR = {
    nl: { to: 'Verzending naar', est: 'Geschatte levering tussen', order: 'Besteld', ship: 'Verzonden', del: 'Levering' },
    en: { to: 'Shipping to', est: 'Estimated delivery between', order: 'Ordered', ship: 'Shipped', del: 'Delivery' },
    de: { to: 'Versand nach', est: 'Voraussichtliche Lieferung zwischen', order: 'Bestellt', ship: 'Versendet', del: 'Lieferung' },
    fr: { to: 'Livraison vers', est: 'Livraison estimée entre', order: 'Commandé', ship: 'Expédié', del: 'Livraison' },
    es: { to: 'Envío a', est: 'Entrega estimada entre', order: 'Pedido', ship: 'Enviado', del: 'Entrega' },
    it: { to: 'Spedizione in', est: 'Consegna stimata tra', order: 'Ordinato', ship: 'Spedito', del: 'Consegna' },
    pl: { to: 'Wysyłka do', est: 'Szacowana dostawa między', order: 'Zamówienie', ship: 'Wysyłka', del: 'Dostawa' }
  };
  var UGD_MONTHS = {
    jan: 0, feb: 1, 'fév': 1, lut: 1, mar: 2, mrt: 2, 'mär': 2, apr: 3, avr: 3, abr: 3, kwi: 3,
    may: 4, mei: 4, mai: 4, mag: 4, maj: 4, jun: 5, giu: 5, cze: 5, jul: 6, lug: 6, lip: 6,
    aug: 7, ago: 7, 'aoû': 7, sie: 7, sep: 8, set: 8, wrz: 8, oct: 9, okt: 9, ott: 9, 'paź': 9,
    nov: 10, lis: 10, dec: 11, dez: 11, dic: 11, 'déc': 11, gru: 11, gen: 0, ene: 0, sty: 0
  };
  function ugdMonth(word) {
    var w = word.toLowerCase().replace(/\./g, '');
    if (w.indexOf('juil') === 0) return 6;
    if (w.indexOf('juin') === 0) return 5;
    return UGD_MONTHS.hasOwnProperty(w.slice(0, 3)) ? UGD_MONTHS[w.slice(0, 3)] : -1;
  }
  function ugdParseSide(text, now) {
    var day = text.match(/\b(\d{1,2})\b/);
    var word = text.match(/[A-Za-zÀ-ž]{3,}/);
    var year = text.match(/\b(20\d{2})\b/);
    if (!day || !word) return null;
    var month = ugdMonth(word[0]);
    if (month < 0) return null;
    var y = year ? parseInt(year[1], 10) : now.getFullYear();
    var date = new Date(y, month, parseInt(day[1], 10));
    if (!year && date < new Date(now.getFullYear(), now.getMonth(), now.getDate() - 1)) date = new Date(y + 1, month, parseInt(day[1], 10));
    return date;
  }
  function ugdParseRange(range, now) {
    var parts = String(range || '').split(/\s[-–—]\s/);
    var from = ugdParseSide(parts[0], now);
    var to = parts[1] ? ugdParseSide(parts[1], now) : from;
    if (!from || !to) return null;
    return from <= to ? { from: from, to: to } : { from: to, to: from };
  }
  function ugdAddWorkdays(date, n) {
    var d = new Date(date.getTime());
    while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0 && d.getDay() !== 6) n--; }
    return d;
  }
  var UGD_ICONS = {
    basket: '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 10h14l-1.4 9H6.4L5 10z"/><path d="M9 10l3-5 3 5"/></svg>',
    truck: '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M2 6h11v10H2zM13 9h4l3 3v4h-7"/><circle cx="7" cy="17.5" r="1.6"/><circle cx="17" cy="17.5" r="1.6"/></svg>',
    home: '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 11l9-7 9 7"/><path d="M5 10v10h14V10"/><path d="M10 20v-6h4v6"/></svg>',
    bigtruck: '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M2 6h11v10H2zM13 9h4l3 3v4h-7"/><circle cx="7" cy="17.5" r="1.6"/><circle cx="17" cy="17.5" r="1.6"/></svg>'
  };
  var ugdStyled = false;
  function ugdInjectStyles() {
    if (ugdStyled) return;
    ugdStyled = true;
    var css = '' +
      '.product-info parcelpanel-edd.ugd-hide{display:none!important}' +
      '.ugd{box-sizing:border-box;margin:18px -6px 0 -9px;border:1px solid #e5e1de;background:#f5f4f3;color:#111;font-family:var(--ugp-body,"DM Sans",Arial,sans-serif);overflow:hidden}' +
      '@media (min-width:1000px){.ugd{margin-inline:0;border-radius:10px}}' +
      '.ugd__top{display:flex;align-items:center;gap:9px;padding:11px 16px;background:#ebe7e4;font-size:13.5px;line-height:1.3;font-weight:500}' +
      '.ugd__flag{flex:0 0 auto;width:20px;height:15px;border-radius:2px;object-fit:cover;box-shadow:0 0 0 1px rgba(0,0,0,.12)}' +
      '.ugd__main{padding:16px 16px 18px}' +
      '.ugd__est{display:flex;align-items:center;gap:13px;margin-bottom:20px}' +
      '.ugd__estIcon{flex:0 0 44px;width:44px;height:44px;border-radius:999px;background:#0b0b0b;color:#fff;display:flex;align-items:center;justify-content:center}' +
      '.ugd__estLabel{display:block;color:#555;font-size:12.5px;line-height:1.35}' +
      '.ugd__estDates{display:block;margin-top:2px;font:700 17px/1.25 var(--ugp-head,Poppins,Arial,sans-serif);letter-spacing:.005em}' +
      '.ugd__track{display:grid;grid-template-columns:repeat(3,minmax(0,1fr))}' +
      '.ugd__step{min-width:0}' +
      '.ugd__row{display:flex;align-items:center}' +
      '.ugd__dot{flex:0 0 32px;width:32px;height:32px;border-radius:999px;background:#e7e2de;color:#111;display:flex;align-items:center;justify-content:center;opacity:0;transform:scale(.6);transition:opacity .35s ease,transform .45s cubic-bezier(.2,1.4,.4,1)}' +
      '.ugd__step--done .ugd__dot,.ugd__step--now .ugd__dot{background:#0b0b0b;color:#fff}' +
      '.ugd__line{position:relative;flex:1;height:2px;margin:0 8px;background:#d9d4d0;border-radius:2px;overflow:hidden}' +
      '.ugd__line::after{content:"";position:absolute;left:0;top:0;bottom:0;width:0;background:#0b0b0b;transition:width .9s cubic-bezier(.4,0,.2,1)}' +
      '.ugd__label{margin-top:9px;padding-right:6px;opacity:0;transition:opacity .4s ease}' +
      '.ugd__label b{display:block;font-size:13px;line-height:1.3;font-weight:500}' +
      '.ugd__label span{display:block;margin-top:2px;color:#666;font-size:12.5px;line-height:1.3}' +
      '.ugd__step--last .ugd__label b{font-weight:700}' +
      '.ugd.is-live .ugd__dot,.ugd.is-live .ugd__label{opacity:1;transform:none}' +
      '.ugd.is-live .ugd__step:nth-child(1) .ugd__dot,.ugd.is-live .ugd__step:nth-child(1) .ugd__label{transition-delay:.1s}' +
      '.ugd.is-live .ugd__step:nth-child(1) .ugd__line::after{width:100%;transition-delay:.4s}' +
      '.ugd.is-live .ugd__step:nth-child(2) .ugd__dot,.ugd.is-live .ugd__step:nth-child(2) .ugd__label{transition-delay:.9s}' +
      '.ugd.is-live .ugd__step:nth-child(2) .ugd__line::after{width:58%;transition-delay:1.3s}' +
      '.ugd.is-live .ugd__step:nth-child(3) .ugd__dot,.ugd.is-live .ugd__step:nth-child(3) .ugd__label{transition-delay:1.9s}' +
      '.ugd.is-live .ugd__step--last .ugd__dot{animation:ugdPulse 2.4s ease-out 2.4s infinite}' +
      '@keyframes ugdPulse{0%{box-shadow:0 0 0 0 rgba(11,11,11,.35)}70%{box-shadow:0 0 0 9px rgba(11,11,11,0)}100%{box-shadow:0 0 0 0 rgba(11,11,11,0)}}' +
      '@media (prefers-reduced-motion:reduce){.ugd__dot,.ugd__label{opacity:1!important;transform:none!important;transition:none!important}.ugd__line::after{transition:none!important}.ugd.is-live .ugd__step--last .ugd__dot{animation:none!important}}';
    var style = document.createElement('style');
    style.setAttribute('data-ugd', '');
    style.textContent = css;
    document.head.appendChild(style);
  }
  function ugdEscape(text) {
    return String(text).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  }
  function renderTimeline() {
    var pp = document.querySelector('.product-info parcelpanel-edd');
    if (!pp) return;
    var result = pp.eddResult;
    var cc = String(pp.country || '').toUpperCase();
    if (!result || !result.edd_range || !/^[A-Z]{2}$/.test(cc)) return;

    var locale = String((window.Shopify && window.Shopify.locale) || document.documentElement.lang || 'en').replace('_', '-');
    var now = new Date();
    var key = [cc, result.edd_range, locale, now.getFullYear(), now.getMonth(), now.getDate()].join('|');
    var existing = document.querySelector('.product-info .ugd');
    if (existing && existing.dataset.key === key) return;

    var range = ugdParseRange(result.edd_range, now);
    if (!range) return;

    var s = UGD_STR[locale.slice(0, 2).toLowerCase()] || UGD_STR.en;
    var countryName = pp.countryName || cc;
    try {
      if (window.Intl && Intl.DisplayNames) countryName = new Intl.DisplayNames([locale], { type: 'region' }).of(cc) || countryName;
    } catch (error) {}

    var fmt;
    try { fmt = new Intl.DateTimeFormat(locale, { day: 'numeric', month: 'short' }); } catch (error) { fmt = new Intl.DateTimeFormat('en', { day: 'numeric', month: 'short' }); }
    function span(a, b) { var x = fmt.format(a), y = fmt.format(b); return x === y ? x : x + ' – ' + y; }

    var orderText = fmt.format(now);
    var shipText = span(ugdAddWorkdays(now, 1), ugdAddWorkdays(now, 3));
    var deliveryText = span(range.from, range.to);

    ugdInjectStyles();

    var html = '' +
      '<div class="ugd__top"><img class="ugd__flag" src="https://flagcdn.com/w40/' + cc.toLowerCase() + '.png" alt="" width="20" height="15" loading="lazy" onerror="this.style.display=\'none\'"><span>' + ugdEscape(s.to) + ' <strong>' + ugdEscape(countryName) + '</strong></span></div>' +
      '<div class="ugd__main">' +
        '<div class="ugd__est"><span class="ugd__estIcon">' + UGD_ICONS.bigtruck + '</span><div><span class="ugd__estLabel">' + ugdEscape(s.est) + '</span><span class="ugd__estDates">' + ugdEscape(deliveryText) + '</span></div></div>' +
        '<div class="ugd__track">' +
          '<div class="ugd__step ugd__step--done"><div class="ugd__row"><span class="ugd__dot">' + UGD_ICONS.basket + '</span><span class="ugd__line"></span></div><div class="ugd__label"><b>' + ugdEscape(s.order) + '</b><span>' + ugdEscape(orderText) + '</span></div></div>' +
          '<div class="ugd__step"><div class="ugd__row"><span class="ugd__dot">' + UGD_ICONS.truck + '</span><span class="ugd__line"></span></div><div class="ugd__label"><b>' + ugdEscape(s.ship) + '</b><span>' + ugdEscape(shipText) + '</span></div></div>' +
          '<div class="ugd__step ugd__step--now ugd__step--last"><div class="ugd__row"><span class="ugd__dot">' + UGD_ICONS.home + '</span></div><div class="ugd__label"><b>' + ugdEscape(s.del) + '</b><span>' + ugdEscape(deliveryText) + '</span></div></div>' +
        '</div>' +
      '</div>';

    var el = document.createElement('div');
    el.className = 'ugd';
    el.dataset.key = key;
    el.setAttribute('role', 'group');
    el.setAttribute('aria-label', s.to + ' ' + countryName + ': ' + s.est + ' ' + deliveryText);
    el.innerHTML = html;

    if (existing) existing.replaceWith(el);
    else pp.insertAdjacentElement('afterend', el);
    pp.classList.add('ugd-hide');

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) { el.classList.add('is-live'); io.disconnect(); }
      }, { threshold: 0.35 });
      io.observe(el);
    } else {
      el.classList.add('is-live');
    }
  }

  function init(root) { formatMoney(root); bindHearts(root); normalizeDelivery(root); normalizeDeadline(root); normalizeReviewA11y(root); renderTimeline(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('variant:change', function () { setTimeout(function () { init(document); }, 0); });
  if (window.MutationObserver) new MutationObserver(function () {
    normalizeDelivery(document);
    normalizeDeadline(document);
    normalizeReviewA11y(document);
    renderTimeline();
  }).observe(document.documentElement, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['aria-label'] });
})();
